import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const backfillAttendanceSheets = createApiThunk<void, { trainingId: string }>(
  "trainingFollowUps/backfillAttendanceSheets",
  async ({ trainingId }, { extra: { adminRepository } }) => {
    return adminRepository!.backfillAttendanceSheets(trainingId);
  },
);

export const resetBackfillAttendanceSheets = createAction("admin/resetBackfillAttendanceSheets");
